import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import AccountInfo from "./Components/AccountInfo";
import Home from "./Components/Home";
import Drops from "./Components/Drops";
import UserProfileBuyer from "./Components/UserProfileBuyer";
import Marketplace from "./Components/Marketplace";
import Collection from "./Components/Collection";
import CollectionOpen from "./Components/CollectionOpen";
import UserProfileArtist from "./Components/UserProfileArtist";
import SpecificItem from "./Components/SpecificItem";
import LoginSignup from "./Components/LoginSignup";
import PlaceBid from "./Components/PlaceBid";
import UpcomingCollection from "./Components/UpcomingCollection";
import FilteredByArtworkDefault from "./Components/FilteredByArtworkDefault";
import FilteredArtworkViewCollection from "./Components/FilteredArtworkViewCollection";
import CollectionDetails from "./Components/CollectionDetails";
import Submitted from "./Components/Submitted";
import ClosedCollection from "./Components/ClosedCollection";
import ClosedCollectionDetails from "./Components/ClosedCollectionDetails";
import PrimaryMarket from "./Components/PrimaryMarket";
import PrimaryMarketRegularSale from "./Components/PrimaryMarketRegularSale";
import PrimaryMarketAuction from "./Components/PrimaryMarketAuction";
import SecondaryMarketRegular from "./Components/SecondarymarketRegular";
import FutureCollecion from "./Components/FutureCollection";
import FutureCollectionDetails from "./Components/FutureCollectionDetails";
import AccountActivityBuyer from "./Components/AccountActivityBuyer";
import AccountActivitySales from "./Components/AccountActivitySales";
import AccountActivityOfferReceived from "./Components/AccountActivityOfferReceived";
import AccountActivityOfferMade from "./Components/AccountActivityOfferMade";
import AccountActivityBid from "./Components/AccountActivityBid";
import PurchaseItemDetails from "./Components/PurchaseItemDetails";
import SalesItemDetails from "./Components/SalesItemDetails";
import OfferRecItemDetails from "./Components/OfferRecItemDetails";
import OfferMadeItemDetails from "./Components/OfferMadeItemDetails";
import WinBid from "./Components/WinBid";
import OutBid from "./Components/OutBid";
import Mint from "./Components/mintCollection";

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Switch>
            <Route path="/AccountInfo" component={AccountInfo} />
            <Route path="/Drops" component={Drops} />
            <Route path="/UserProfileBuyer" component={UserProfileBuyer} />
            <Route path="/Marketplace" component={Marketplace} />
            <Route exact path="/Collection" component={Collection} />
            <Route exact path="/Collection/:id" component={CollectionOpen} />
            <Route path="/UserProfileArtist" component={UserProfileArtist} />
            <Route exact path="/SpecificItem" component={SpecificItem} />
            <Route
              exact
              path="/SpecificItem/:collection/:address/:id"
              component={SpecificItem}
            />
            <Route path="/LoginSignup" component={LoginSignup} />
            <Route exact path="/PlaceBid" component={PlaceBid} />
            <Route
              exact
              path="/PlaceBid/:collection/:address/:id"
              component={PlaceBid}
            />
            <Route path="/UpcomingCollection" component={UpcomingCollection} />
            <Route
              path="/FilteredByArtworkDefault"
              component={FilteredByArtworkDefault}
            />
            <Route
              path="/FilteredArtworkViewCollection"
              component={FilteredArtworkViewCollection}
            />
            <Route path="/CollectionDetails" component={CollectionDetails} />
            <Route path="/Submitted" component={Submitted} />
            <Route exact path="/mintcollection/:id" component={Mint} />
            <Route path="/ClosedCollection" component={ClosedCollection} />
            <Route
              path="/CLosedCollectionDetails"
              component={ClosedCollectionDetails}
            />
            <Route path="/PrimaryMarket" component={PrimaryMarket} />
            <Route
              path="/PrimaryMarketRegularSale"
              component={PrimaryMarketRegularSale}
            />
            <Route
              path="/PrimaryMarketAuction"
              component={PrimaryMarketAuction}
            />
            <Route
              path="/SecondaryMarketRegular"
              component={SecondaryMarketRegular}
            />
            <Route path="/FutureCollection" component={FutureCollecion} />
            <Route
              path="/FutureCollectionDetails"
              component={FutureCollectionDetails}
            />
            <Route
              path="/AccountActivityBuyer"
              component={AccountActivityBuyer}
            />
            <Route
              path="/AccountActivitySales"
              component={AccountActivitySales}
            />
            <Route
              path="/AccountActivityOfferReceived"
              component={AccountActivityOfferReceived}
            />
            <Route
              path="/AccountActivityOfferMade"
              component={AccountActivityOfferMade}
            />
            <Route path="/AccountActivityBid" component={AccountActivityBid} />
            <Route
              path="/PurchaseItemDetails"
              component={PurchaseItemDetails}
            />
            <Route path="/SalesItemDetails" component={SalesItemDetails} />
            <Route
              path="/OfferRecItemDetails"
              component={OfferRecItemDetails}
            />
            <Route
              path="/OfferMadeItemDetails"
              component={OfferMadeItemDetails}
            />
            <Route path="/WinBid" component={WinBid} />
            <Route path="/OutBid" component={OutBid} />
            <Route path="/" component={Home} />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
